export const DARK_SWITCH_REQUEST = 'DARK_SWITCH_REQUEST';
export const DARK_SWITCH_REQUEST_SUCCESS = 'DARK_SWITCH_REQUEST_SUCCESS';
